import PropTypes from 'prop-types';

export const LINK_TYPE_WEB = 'link-web';
export const LINK_TYPE_DOC = 'link-document';
export const LINK_TYPE_MEDIA = 'link-media';

export const AlternateType = PropTypes.shape({
  to: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
});

export const AlternatesType = PropTypes.shape({
  fr: AlternateType,
  en: AlternateType,
});

export const BasicLink = {
  linkType: PropTypes.string.isRequired,
  title: PropTypes.string,
  url: PropTypes.string,
};

export const DownloadLink = {
  linkType: PropTypes.string.isRequired,
  title: PropTypes.string,
  download: PropTypes.boolean,
};

export const CtaLink = {
  linkType: PropTypes.string.isRequired,
  title: PropTypes.string,
  cta: PropTypes.boolean,
};

export const MediaLink = {
  linkType: PropTypes.string.isRequired,
  name: PropTypes.string,
  kind: PropTypes.string,
  url: PropTypes.string,
  size: PropTypes.string,
};

export const ContentLink = {
  linkType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  slug: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
};

export const OtherLink = {
  to: PropTypes.string.isRequired,
};

export const BasicLinkType = PropTypes.shape(BasicLink);
export const DownloadLinkType = PropTypes.shape(DownloadLink);
export const CtaLinkType = PropTypes.shape(CtaLink);
export const ContentLinkType = PropTypes.shape(ContentLink);
export const MediaLinkType = PropTypes.shape(MediaLink);
export const OtherLinkType = PropTypes.shape(OtherLink);

export const LinkType = PropTypes.oneOfType([
  BasicLinkType,
  DownloadLinkType,
  CtaLinkType,
  ContentLinkType,
  OtherLinkType,
  MediaLinkType,
]);

export default LinkType.isRequired;
